// extracted by mini-css-extract-plugin
module.exports = {"subHeader":"postDetails-module--subHeader--1WiYZ","postInfo":"postDetails-module--postInfo--1Hlg8","infoText":"postDetails-module--infoText--1HYTP"};